import {AccordionAnkerLinks} from "./Components/accordionAnkerLinks";
import {Rating} from "./Components/rating";
import {ClickCounter} from "./Components/clickCounter";
import {Bookmark} from "./Components/bookmark";
import {VimeoVideo} from "./Components/vimeoVideo";

(function ($) {
	new AccordionAnkerLinks();
	new Rating();
	new ClickCounter();
	new Bookmark();
	new VimeoVideo();
})(jQuery);
